import React, { FC, useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react";
import ProductsSlider from "common/ProductsSlider/ProductsSlider";
import ProductPreview from "common/ProductPreview/ProductPreview";
import { useStore } from "store";
import { useApi } from "services/ApiService";
import { gtm } from "helpers/analytics";
import { TABLET } from "constants/mixins";

type Props = {
  hideCartToast?: boolean;
};

const ProductsOfDay: FC<Props> = ({ hideCartToast }) => {
  const { location } = useStore();
  const [list, setList] = useState(new Array(10).fill(undefined));
  const [sliderIsInit, setSliderIsInit] = useState(false);
  const {
    methods: { products },
  } = useApi();

  useEffect(() => {
    async function fetchProducts() {
      const { data, errors } = await products.goodsOfDay({
        regionID: location.regionID,
      });
      if (data && data.goodsOfDay.items) {
        setList(data.goodsOfDay.items);
      }

      if (errors) {
        setList([]);
      }
    }

    fetchProducts();
  }, [location.regionID, products]);

  const onWatchSlide = useCallback(
    ({ subject, isIntersecting, index }) => {
      if (isIntersecting) {
        gtm.watchProduct(subject, index + 1, "Товары дня", subject?.category);
      }
    },
    [sliderIsInit]
  );

  if (list.length === 0) return null;

  return (
    <section>
      <ProductsSlider
        title="Товары дня"
        sliderProps={{
          onInit: () => {
            setSliderIsInit(true);
          },
          slidesPerView: "auto",
          loop: false,
          breakpoints: {
            [TABLET]: {
              navigation: false,
            },
          },
          touchStartPreventDefault: false,
        }}
      >
        {list.map((product, index) => {
          return (
            <ProductPreview
              onWatch={sliderIsInit ? onWatchSlide : undefined}
              product={product}
              index={index}
              key={index}
              type={product ? "regular" : "regularSkeleton"}
              analyticsMeta={{
                position: index + 1,
                list: "Товары дня",
                category: product?.category,
              }}
              ellipsis={3}
              hideCartToast={hideCartToast}
              enableCustomPrefixPrice
            />
          );
        })}
      </ProductsSlider>
    </section>
  );
};

export default observer(ProductsOfDay);
